import React, { useEffect, useState, useRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import modalstyles from '../css/share/share-modal.module.css';
import styles from '../css/share/manage-shares-modal.module.css';
import { deleteShareCodes, getShareCodes } from '../../adapters/share-adapter';

function ManageSharesModal({ userId, closeModal }) {
    const [sharesForUser, setSharesForUser] = useState([]);
    const [visibleItems, setVisibleItems] = useState();
    const [isSelectAllChecked, setSelectAllChecked] = useState(false);
    const [selectedShares, setSelectedShares] = useState({});
    const searchInputRef = useRef();

    const [deleteError, setDeleteError] = useState(false);
    const [justDeleted, setJustDeleted] = useState(false);

    useEffect(async () => {
        const result = await getShareCodes({ userId: userId });
        if (result?.shares) {
            setSharesForUser(result.shares);
            setVisibleItems(result.shares);
        }
    }, [userId])

    const updateCheckedItems = (e, item) => {
        setSelectedShares((prev) => {
            const updated = { ...prev };
            if (e.target.checked) {
                updated[item.shareCode] = item;
            } else {
                delete updated[item.shareCode];
            }
            return updated;
        });
    };

    const toggleAll = (e) => {
        if (e.target.checked) {
            setSelectedShares((prev) => {
                const updated = { ...prev };
                visibleItems.forEach((item) => {
                    updated[item.shareCode] = item;
                });
                return updated;
            });
            setSelectAllChecked(true);
        } else {
            setSelectedShares((prev) => {
                const updated = { ...prev };
                visibleItems.forEach((item) => {
                    delete updated[item.shareCode];
                });
                return updated;
            });
            setSelectAllChecked(false);
        }
    };

    const handleSearch = () => {
        const value = searchInputRef.current.value;
        const foundShares = sharesForUser.filter(share => share.shareCode === value);
        setVisibleItems(foundShares);
    }

    const handleFilter = (e) => {
        if (e.target.value === 'flow' || e.target.value === 'story') {
            const matchedShares = sharesForUser.filter(share => share.shareType === e.target.value);
            setVisibleItems(matchedShares);
        }
        else if (e.target.value === "") {
            setVisibleItems(sharesForUser);
        }
        else if (e.target.value === "selected") {
            setVisibleItems(Object.values(selectedShares));
        }
    }

    const selectedCount = Object.keys(selectedShares).length;
    const getDeleteButtonText = () => {
        let text = "Delete";

        if (selectedCount === 1) {
            text = 'Delete 1 Share';
        }
        else if (selectedCount > 1) {
            text = `Delete ${selectedCount} Shares`;
        }

        if (justDeleted) {
            text = 'Deleted!';
        }

        return text;
    }

    const handleDelete = async () => {
        const shareCodesToDelete = Object.keys(selectedShares);
        const result = await deleteShareCodes(shareCodesToDelete);
        if (!result || result.deletedCount === 0) {
            setDeleteError(true);
        }
        else {
            setJustDeleted(true);
            setTimeout(() => {
                setJustDeleted(false);
            }, 1500);

            setVisibleItems(prev => prev.filter(item => !selectedShares[item.shareCode]));
            setSelectedShares({});
            const updatedShares = await getShareCodes({ userId: userId });
            setSharesForUser(updatedShares);
            setSelectAllChecked(false);
        }
    }

    return (
        <div className={modalstyles.modalContainer} onClick={closeModal}>
            <div className={`${modalstyles.shareModal} ${modalstyles.modalCentered} ${styles.manageSharesModal}`} onClick={(e) => e.stopPropagation()}>
                <div className={modalstyles.header}>
                    <h3 className={modalstyles.shareTitle}>Manage your shares</h3>
                    <button className={modalstyles.closeButton} onClick={closeModal}>×</button>
                </div>
                <div className={`${styles.flexDiv} ${styles.wrap}`}>
                    <div className={styles.flexDiv}>
                        <div className={`${styles.searchContainer}`}>
                            <input ref={searchInputRef} type="text" placeholder="Search by code" className={`${styles.searchInput}`} />
                            <button className={styles.searchButton} onClick={handleSearch}>
                                🔍
                            </button>
                        </div>
                        <select className={styles.filterDropdown} defaultValue="" onChange={handleFilter}>
                            <option value="">Filter by type</option>
                            <option value="flow">Flows</option>
                            <option value="story">Stories</option>
                            <option value="selected">All selected</option>
                        </select>
                    </div>
                </div>
                <div style={{ margin: '1.5rem 0' }}>
                    <div className={`${styles.shareRow} ${styles.topRow}`}>
                        <input className={styles.selectAllCheckbox} type="checkbox"
                            disabled={!visibleItems || visibleItems.length === 0}
                            checked={isSelectAllChecked}
                            onChange={toggleAll}
                        />
                        <p className={styles.rowHeading}>Share Code</p>
                        <p className={styles.rowHeading}>Type</p>
                    </div>
                    {/* <div className={styles.rowsContainer}>
                        {visibleItems?.length > 0 ?
                            visibleItems.map((item) =>
                                <div key={item.shareCode} className={styles.shareRow}>
                                    <input className={styles.shareCheckbox} type="checkbox"
                                        checked={selectedShares[item.shareCode] !== undefined}
                                        onChange={(e) => updateCheckedItems(e, item)}
                                    />
                                    <p className={styles.shareInfo}>{item.shareCode}</p>
                                    <p className={styles.shareInfo}>{item.shareType}</p>
                                </div>
                            )
                            : <p style={{ fontSize: '14px' }}>No shares found</p>
                        }
                    </div> */}
                    {visibleItems?.length > 0 ? (
                        <TransitionGroup className={styles.rowsContainer}>
                            {visibleItems.map((item) => (
                                <CSSTransition
                                    key={item.shareCode}
                                    timeout={300}
                                    classNames={{
                                        enter: styles.fadeEnter,
                                        enterActive: styles.fadeEnterActive,
                                        exit: styles.fadeExit,
                                        exitActive: styles.fadeExitActive,
                                    }}
                                >
                                    <div className={styles.shareRow}>
                                        <input
                                            className={styles.shareCheckbox}
                                            type="checkbox"
                                            checked={selectedShares[item.shareCode] !== undefined}
                                            onChange={(e) => updateCheckedItems(e, item)}
                                        />
                                        <p className={styles.shareInfo}>{item.shareCode}</p>
                                        <p className={styles.shareInfo}>{item.shareType}</p>
                                    </div>
                                </CSSTransition>
                            ))}
                        </TransitionGroup>
                    ) : (
                        <p className={styles.noSharesText}>No shares found</p>
                    )}
                    <div className={styles.deleteDiv}>
                        <button disabled={selectedCount === 0} className={styles.deleteButton}
                            onClick={handleDelete}
                        >
                            {getDeleteButtonText()}
                        </button>
                        {deleteError && <p className={styles.deleteError}>Hmm please try again.</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageSharesModal;